import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "medicalSchoolNameContainer",
    "specialtyContainer",
    "programSiteContainer",
    "associationNameContainer",
    "recaptcha",
    "token",
  ];

  static values = {
    sitekey: String,
  };

  initialize() {
    this.roleFieldsMapping = {
      MEDICAL_SCHOOL_STAFF: [this.medicalSchoolNameContainerTarget],
      PROGRAM_STAFF: [this.specialtyContainerTarget, this.programSiteContainerTarget],
      RESIDENT_SITE_STAFF: [this.programSiteContainerTarget],
      ASSOCIATION_STAFF: [this.associationNameContainerTarget],
      PROSPECTIVE_RESIDENT: [],
    };

    this.handleRoleChange();

    this.roleInputs = this.element.querySelectorAll('input[name="role"]');
    this.roleInputs.forEach((el) =>
      el.addEventListener("change", this.handleRoleChange.bind(this))
    );

    this.phoneInput = this.element.querySelector('input[name="phone_number"]');
    if (this.phoneInput) {
      this.phoneInput.addEventListener("input", this.formatPhoneNumber.bind(this));
    }
  }

  connect() {
    if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
      this.renderReCaptcha();
    } else {
      window.onRecaptchaLoaded = () => {
        this.renderReCaptcha();
      };
    }
  }

  renderReCaptcha() {
    const oldElement = this.recaptchaTarget;
    const newElement = oldElement.cloneNode(false);
    oldElement.parentNode.replaceChild(newElement, oldElement);

    try {
      this.widgetId = grecaptcha.enterprise.render(newElement, {
        sitekey: this.sitekeyValue,
        size: "invisible",
        callback: (tok) => this.onRecaptchaSuccess(tok),
        "expired-callback": () => this.onRecaptchaExpired(),
        "error-callback": () => this.onRecaptchaError(),
        action: "request_info_form"
      });
    } catch (error) {
      console.error("Error rendering reCAPTCHA Enterprise:", error);
    }
  }

  submit(event) {
    event.preventDefault();
    grecaptcha.enterprise.execute(this.widgetId);
  }

  onRecaptchaSuccess(token) {
    this.tokenTarget.value = token;
    
    const formData = new FormData(this.element);
    
    const csrfToken = document.querySelector('input[name="csrfmiddlewaretoken"]').value;
    
    fetch(this.element.action, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRFToken': csrfToken,
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      const turboFrame = document.getElementById('show_modal');
      if (turboFrame) {
        turboFrame.innerHTML = html;
      } else {
        console.error('Could not find turbo-frame with id "show_modal"');
      }
    })
    .catch(error => {
      console.error('Error submitting form:', error);
      alert('There was an error submitting the form. Please try again.');
    });
  }

  onRecaptchaExpired() {
    grecaptcha.enterprise.reset(this.widgetId);
  }

  onRecaptchaError() {
    alert("Network error. Please try again.");
  }

  hideAllContainer(e) {
    const containers = [
      this.medicalSchoolNameContainerTarget,
      this.specialtyContainerTarget,
      this.programSiteContainerTarget,
      this.associationNameContainerTarget,
    ];
    containers.forEach((el) => {
      el.classList.add("hidden");
      if (e) {
        const input = el.querySelector("input, textarea, select");
        input.value = "";
      }
    });
  }

  handleRoleChange(e) {
    this.hideAllContainer(e);
    const checkedRole = this.element.querySelector('input[name="role"]:checked');
    if (!checkedRole) return;
    const containers = this.roleFieldsMapping[checkedRole.value];
    if (!containers) return;
    containers.forEach((el) => el.classList.remove("hidden"));
  }

  formatPhoneNumber(e) {
    let input = e.target;
    let value = input.value.replace(/\D/g, "").slice(0, 10);
    let formatted = value;
    if (value.length > 6) {
      formatted = value.replace(/(\d{3})(\d{3})(\d{0,4})/, "$1-$2-$3");
    } else if (value.length > 3) {
      formatted = value.replace(/(\d{3})(\d{0,3})/, "$1-$2");
    }
    input.value = formatted;
  }
}
